import {Model, ModelMixin} from '../../common/model.class';

export class WorkHistoryNotes extends ModelMixin() implements Model<WorkHistoryNotes> {

    TYPE = WorkHistoryNotes;

    public notes?: string;

    constructor(jsonData: any = {}) {
        super();
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/work/work-history-notes/work-history-notes.model.ts